var map = {
	"./Aatrox_0.jpg": 120,
	"./Ahri_0.jpg": 121,
	"./Akali_0.jpg": 122,
	"./Akshan_0.jpg": 123,
	"./Alistar_0.jpg": 124,
	"./Amumu_0.jpg": 125,
	"./Anivia_0.jpg": 126,
	"./Annie_0.jpg": 127,
	"./Aphelios_0.jpg": 128,
	"./Ashe_0.jpg": 129,
	"./AurelionSol_0.jpg": 130,
	"./Azir_0.jpg": 131,
	"./Bard_0.jpg": 132,
	"./Blitzcrank_0.jpg": 133,
	"./Brand_0.jpg": 134,
	"./Braum_0.jpg": 135,
	"./Caitlyn_0.jpg": 136,
	"./Camille_0.jpg": 137,
	"./Cassiopeia_0.jpg": 138,
	"./Chogath_0.jpg": 139,
	"./Corki_0.jpg": 140,
	"./Darius_0.jpg": 141,
	"./Diana_0.jpg": 142,
	"./DrMundo_0.jpg": 143,
	"./Draven_0.jpg": 144,
	"./Ekko_0.jpg": 145,
	"./Elise_0.jpg": 146,
	"./Evelynn_0.jpg": 147,
	"./Ezreal_0.jpg": 148,
	"./Fiddlesticks_0.jpg": 149,
	"./Fiora_0.jpg": 150,
	"./Fizz_0.jpg": 151,
	"./Galio_0.jpg": 152,
	"./Gangplank_0.jpg": 153,
	"./Garen_0.jpg": 154,
	"./Gnar_0.jpg": 155,
	"./Gragas_0.jpg": 156,
	"./Graves_0.jpg": 157,
	"./Gwen_0.jpg": 158,
	"./Hecarim_0.jpg": 159,
	"./Heimerdinger_0.jpg": 160,
	"./Illaoi_0.jpg": 161,
	"./Irelia_0.jpg": 162,
	"./Ivern_0.jpg": 163,
	"./Janna_0.jpg": 164,
	"./JarvanIV_0.jpg": 165,
	"./Jax_0.jpg": 166,
	"./Jayce_0.jpg": 167,
	"./Jhin_0.jpg": 168,
	"./Jinx_0.jpg": 169,
	"./Kaisa_0.jpg": 170,
	"./Kalista_0.jpg": 171,
	"./Karma_0.jpg": 172,
	"./Karthus_0.jpg": 173,
	"./Kassadin_0.jpg": 174,
	"./Katarina_0.jpg": 175,
	"./Kayle_0.jpg": 176,
	"./Kayn_0.jpg": 177,
	"./Kennen_0.jpg": 178,
	"./Khazix_0.jpg": 179,
	"./Kindred_0.jpg": 180,
	"./Kled_0.jpg": 181,
	"./KogMaw_0.jpg": 182,
	"./Leblanc_0.jpg": 183,
	"./LeeSin_0.jpg": 184,
	"./Leona_0.jpg": 185,
	"./Lillia_0.jpg": 186,
	"./Lissandra_0.jpg": 187,
	"./Lucian_0.jpg": 188,
	"./Lulu_0.jpg": 189,
	"./Lux_0.jpg": 190,
	"./Malphite_0.jpg": 191,
	"./Malzahar_0.jpg": 192,
	"./Maokai_0.jpg": 193,
	"./MasterYi_0.jpg": 194,
	"./MissFortune_0.jpg": 195,
	"./MonkeyKing_0.jpg": 196,
	"./Mordekaiser_0.jpg": 197,
	"./Morgana_0.jpg": 198,
	"./Nami_0.jpg": 199,
	"./Nasus_0.jpg": 200,
	"./Nautilus_0.jpg": 201,
	"./Neeko_0.jpg": 202,
	"./Nidalee_0.jpg": 203,
	"./Nocturne_0.jpg": 204,
	"./Nunu_0.jpg": 205,
	"./Olaf_0.jpg": 206,
	"./Orianna_0.jpg": 207,
	"./Ornn_0.jpg": 208,
	"./Pantheon_0.jpg": 209,
	"./Poppy_0.jpg": 210,
	"./Pyke_0.jpg": 211,
	"./Qiyana_0.jpg": 212,
	"./Quinn_0.jpg": 213,
	"./Rakan_0.jpg": 214,
	"./Rammus_0.jpg": 215,
	"./RekSai_0.jpg": 216,
	"./Rell_0.jpg": 217,
	"./Renata_0.jpg": 218,
	"./Renekton_0.jpg": 219,
	"./Rengar_0.jpg": 220,
	"./Risen_0.jpg": 221,
	"./Riven_0.jpg": 222,
	"./Rumble_0.jpg": 223,
	"./Ryze_0.jpg": 224,
	"./Samira_0.jpg": 225,
	"./Sejuani_0.jpg": 226,
	"./Senna_0.jpg": 227,
	"./Seraphine_0.jpg": 228,
	"./Sett_0.jpg": 229,
	"./Shaco_0.jpg": 230,
	"./Shen_0.jpg": 231,
	"./Shyvana_0.jpg": 232,
	"./Singed_0.jpg": 233,
	"./Sion_0.jpg": 234,
	"./Sivir_0.jpg": 235,
	"./Skarner_0.jpg": 236,
	"./Sona_0.jpg": 237,
	"./Soraka_0.jpg": 238,
	"./Swain_0.jpg": 239,
	"./Sylas_0.jpg": 240,
	"./Syndra_0.jpg": 241,
	"./TahmKench_0.jpg": 242,
	"./Taliyah_0.jpg": 243,
	"./Talon_0.jpg": 244,
	"./Taric_0.jpg": 245,
	"./Teemo_0.jpg": 246,
	"./Thresh_0.jpg": 247,
	"./Tristana_0.jpg": 248,
	"./Trundle_0.jpg": 249,
	"./Tryndamere_0.jpg": 250,
	"./TwistedFate_0.jpg": 251,
	"./Twitch_0.jpg": 252,
	"./Udyr_0.jpg": 253,
	"./Urgot_0.jpg": 254,
	"./Varus_0.jpg": 255,
	"./Vayne_0.jpg": 256,
	"./Veigar_0.jpg": 257,
	"./Velkoz_0.jpg": 258,
	"./Vex_0.jpg": 259,
	"./Vi_0.jpg": 260,
	"./Viego_0.jpg": 261,
	"./Viktor_0.jpg": 262,
	"./Vladimir_0.jpg": 263,
	"./Volibear_0.jpg": 264,
	"./Warwick_0.jpg": 265,
	"./Xayah_0.jpg": 266,
	"./Xerath_0.jpg": 267,
	"./XinZhao_0.jpg": 268,
	"./Yasuo_0.jpg": 269,
	"./Yone_0.jpg": 270,
	"./Yorick_0.jpg": 271,
	"./Yuumi_0.jpg": 272,
	"./Zac_0.jpg": 273,
	"./Zed_0.jpg": 274,
	"./Zeri_0.jpg": 275,
	"./Ziggs_0.jpg": 276,
	"./Zilean_0.jpg": 277,
	"./Zoe_0.jpg": 278,
	"./Zyra_0.jpg": 279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 999;